<template>
  <main class="main community community_write" role="main">
    <div class="main_con">
      <div class="ttl border">
        <input
          placeholder="제목을 입력하세요."
          maxlength="50"
          v-model.trim="form.title"
        />
      </div>
      <div class="textarea border high_30">
        <textarea
          placeholder="내용을 입력하세요."
          v-model.trim="form.contents"
        />
      </div>
      <div class="img_box_wrap">
        <div class="img_box" v-for="(item, index) in form.images" :key="index">
          <img alt="" :src="item.imagePath" />
          <button @click.stop="removeImage(item, index)">
            <i class="i_x_w"></i>
          </button>
        </div>
      </div>
      <div class="btm_btn">
        <div class="attach_btn border">
          <div class="attach_box" @click.stop="uploadImage">
            <i class="i_img_upload"></i>
            사진첨부
          </div>
          <div class="toggle_box">
            <span>익명</span>
            <div class="toggle_switch">
              <input
                type="checkbox"
                id="switch"
                v-model="form.isAnonymous"
                true-value="Y"
                false-value="N"
              /><label for="switch"></label>
            </div>
          </div>
        </div>
        <ImageInput ref="imageInput" @change="changeImage" />
        <div class="btn_wrap">
          <button class="btn" @click="fnSave">글쓰기</button>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div class="made_toast_layer_common" style="top:80%;" v-if="isViewToast">
        <div class="toast_msg">{{ errorMessage }}</div>
      </div>
    </transition>
    <DesignPopup :show="openDesignPopup" :data="popupParams" @close="confirm" />
  </main>
</template>

<script>
import {
  mapGetters as communityGetters,
  mapActions as communityMapActions,
} from '@common/store/modules/community';
import * as communityTypes from '@common/store/modules/community/types';

import DesignPopup from '@/common/components/modal/DesignPopup.vue';
import ImageInput from '@common/components/ImageInput';

export default {
  name: 'community-board-write',
  description: '커뮤니티 > 자유게시판 작성',
  components: {
    DesignPopup,
    ImageInput,
  },
  data() {
    return {
      boardId: this.$route.query.boardId || '',
      form: {
        title: '',
        contents: '',
        isAnonymous: 'N',
        images: [],
        imageFile: [],
      },
      removeFiles: [],
      isViewToast: false,
      errorMessage: '',
      openDesignPopup: false,
      popupParams: {},
      mode: 'CREATE', // CREATE: 등록, UPDATE: 수정
    };
  },
  created() {
    if (this.boardId) {
      this.form.id = this.boardId;
      this[communityTypes.FETCH_BOARD]({ id: this.boardId, isRead: 'N' }).then(
        () => {
          this.mode = 'UPDATE';
          this.form.title = this.board.title;
          this.form.contents = this.board.contents;
          this.form.isAnonymous = this.board.writer === '익명' ? 'Y' : 'N';
          this.form.images = this.board.images;
        },
      );
    }
  },
  computed: {
    ...communityGetters({ board: communityTypes.FETCH_BOARD }),
  },
  methods: {
    ...communityMapActions([
      communityTypes.FETCH_BOARD,
      communityTypes.CREATE_BOARD,
      communityTypes.UPDATE_BOARD,
    ]),
    fnSave() {
      if (!this.form.title) {
        this.errorMessage = '제목을 입력해주세요';
        this.toastView();
        return;
      }
      if (!this.form.contents) {
        this.errorMessage = '내용을 입력해주세요';
        this.toastView();
        return;
      }
      if (this.form.title.length < 4) {
        this.errorMessage = '제목을 4자 이상 입력해주세요';
        this.toastView();
        return;
      }
      if (this.form.contents.length < 4) {
        this.errorMessage = '내용을 4자 이상 입력해주세요';
        this.toastView();
        return;
      }
      if (this.form.images.length > 10) {
        this.errorMessage = '사진등록은 10장까지 가능합니다';
        this.toastView();
        return;
      }
      this.popupParams = {
        type: 'confirm',
        msg: `글을 ${this.mode === 'CREATE' ? '등록' : '수정'} 하시겠습니까?`,
      };
      this.openDesignPopup = true;
    },
    confirm(isSave) {
      if (isSave) {
        const payload = this.convertToFormData();
        if (this.mode === 'CREATE') {
          this[communityTypes.CREATE_BOARD](payload).then(() => {
            this.popupParams = { type: 'alert', msg: '글이 등록되었습니다' };
          });
        } else {
          this[communityTypes.UPDATE_BOARD](payload).then(() => {
            this.popupParams = { type: 'alert', msg: '글이 수정되었습니다' };
          });
        }
      } else {
        this.openDesignPopup = false;
        if (this.popupParams.type === 'alert') {
          this.$router.go(-1);
        }
      }
    },
    convertToFormData() {
      const payload = new FormData();

      for (const [key, value] of Object.entries(this.form)) {
        if (key !== 'images') {
          payload.append(key, value);
        }
      }

      // 새로 등록된 파일
      if (this.form.images.length > 0) {
        for (const i in this.form.images) {
          if (this.form.images[i].file) {
            payload.append('attachFile', this.form.images[i].file);
          }
        }
      }

      // 삭제된 파일
      if (this.removeFiles.length > 0) {
        for (const i in this.removeFiles) {
          if (this.removeFiles[i].id) {
            payload.append('removeAttachmentFile', this.removeFiles[i].id);
          }
        }
      }

      return payload;
    },
    uploadImage() {
      if (this.form.images.length > 9) {
        this.errorMessage = '사진등록은 10장까지 가능합니다';
        this.toastView();
        return;
      }
      this.$refs.imageInput.click();
    },
    changeImage(file) {
      console.log('filefilefilefilefile');
      console.log(file);

      if (this.form.images.length > 0) {
        this.form.imageFile = this.form.images;
        this.form.images = file;
        this.form.images.push(...this.form.imageFile);
      } else {
        this.form.images = file;
      }

      console.log('this.form.images');
      console.log(this.form.images);
    },
    removeImage(item, idx) {
      this.form.images.splice(idx, 1);
      this.removeFiles.push(item);
    },
    toastView() {
      this.isViewToast = true;
      setTimeout(() => {
        this.isViewToast = false;
      }, 2000);
    },
  },
};
</script>

<style></style>
